module.exports = __webpack_public_path__ + "img/i_instagram.2d4361d2.svg";